/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Select_Guide_PromptInputs */



/**
* | output |
* | --- |
* | "Select a style guide from the list above to begin." |
*
* @param {Style_Guide_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_select_guide_prompt = /** @type {((inputs?: Style_Guide_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un guide de style dans la liste ci-dessus pour commencer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Styleguide aus der obigen Liste aus, um zu beginnen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per iniziare, seleziona una guida di stile dall'elenco sopra.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите стиль оформления из списка выше, чтобы начать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una guía de estilo de la lista anterior para comenzar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从上面的列表中选择一个风格指南开始。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには、上のリストからスタイル ガイドを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरुआत करने के लिए ऊपर दी गई सूची से एक स्टाइल गाइड चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um guia de estilo da lista acima para começar.")
	return /** @type {LocalizedString} */ ("Select a style guide from the list above to begin.")
});